import { useCallback, useEffect, useMemo, useState } from "react";
import { useField } from "formik";
import { useAppContext } from "../../../common/ApplicationServicesContext";

const RadioButtonList = ({ name, onSelect, heading, labelStylingCb = () => { } }) => {
    const { domain } = useAppContext();
    const [data, setData] = useState([]);
    const [selectedValue, setSelectedValue] = useState(domain._id);

    const [field] = useField(name);

    useEffect(() => {
        if (field.value) {
            setData([...field.value]);
        }
    }, [field.value]);

    const handleSelect = useCallback((id) => {
        setSelectedValue(id);
        onSelect(id);
    }, [setSelectedValue, onSelect]);

    // Arrow key navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (data.length === 0) return;

            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                e.preventDefault();

                const currentIndex = data.findIndex(item => item._id === selectedValue);
                let nextIndex;

                if (e.key === "ArrowDown") {
                    nextIndex = currentIndex < data.length - 1 ? currentIndex + 1 : 0;
                } else {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : data.length - 1;
                }

                handleSelect(data[nextIndex]._id);
            }

            if (["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key)) {
                if (Number(e.key) > 0 && Number(e.key) <= data.length) {
                    handleSelect(data[(Number(e.key) - 1) % 10]._id);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [data, selectedValue, handleSelect]);

    const renderButtons = useMemo(() => (
        data.map((element, index) => (
            <div className={`form-check clickable`} key={index} onClick={() => handleSelect(element._id)}>
                <input
                    className="form-check-input clickable"
                    name="domainRadio"
                    type="radio"
                    onChange={() => handleSelect(element._id)}
                    checked={element._id === selectedValue}
                ></input>
                <label className={`form-check-label clickable ${labelStylingCb(element)}`}>{element.name}</label>
            </div>
        ))
    ), [data, selectedValue, labelStylingCb, handleSelect]);

    return (
        <div className="">
            <label htmlFor="list-items" className="form-label h6 d-block">{heading}</label>
            {renderButtons}
        </div>
    );
};

export default RadioButtonList;